export const getTodayDate = () => {
  const today = new Date();
  return new Date(today.getFullYear(), today.getMonth(), today.getDate());
};

export const getTodayDateString = () => {
  return getTodayDate().toISOString().split("T")[0];
};

export const dateToDateString = (date: Date) => {
  return date.toISOString().split("T")[0];
};
